import * as React from 'react'

export const UserInterfaceDesign: React.FC = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0'
    y='0'
    viewBox='0 0 210 210'
    xmlSpace='preserve'
  >
    <style>{`.st0UIDesign{fill:none;stroke:var(--color-badge-text);stroke-width:1.25;stroke-miterlimit:10}.st5UIDesign{enable-background:new; fill:var(--color-badge-text)}.st6UIDesign{fill:none;stroke:#3c388f;stroke-width:1.25;stroke-miterlimit:9.9999}.st8UIDesign{fill:none;stroke:var(--color-badge-text);stroke-width:1.27;stroke-linecap:round;stroke-linejoin:round}`}</style>
    <path
      className='st0UIDesign'
      d='M150.7 59.4c29.3 25.2 32.7 69.4 7.6 98.7s-69.4 32.7-98.7 7.6S26.8 96.3 52 67c3.6-4.2 7.7-8 12.2-11.2'
    />
    <circle cx='91.6' cy='96.4' r='1.9' opacity='.6' fill='#a5a5ff' />
    <circle
      cx='91.6'
      cy='96.4'
      r='4.6'
      opacity='.4'
      fill='none'
      stroke='#a5a5ff'
      stroke-miterlimit='10'
    />
    <circle
      cx='91.6'
      cy='96.4'
      r='8.2'
      opacity='.2'
      fill='none'
      stroke='#a5a5ff'
      stroke-miterlimit='10'
    />
    <path
      fill='#a5a5ff'
      d='m119.9 118.8.9-9.9-21.5-13.1-4.2 2.9 4.7 24.7 9.6 2.7 8.7 12.6 10.5-7.3z'
    />
    <path
      d='m10.3 107.6-9.6-1.1.2-1.8 9.4 1c2.4.3 3.6-1 3.9-3.3.2-2.2-.6-3.7-3-4l-9.4-1 .2-1.7 9.6 1.1c3.4.4 4.5 2.9 4.2 6-.4 3-2 5.2-5.5 4.8zM12.5 90.8l.5-1.7c2.4.5 4-.6 4.8-3.2.6-1.9.1-3.5-1.6-4-1.9-.6-2.8.9-4.1 3.2-1.3 2.3-2.6 4.1-5.2 3.3-2.3-.7-3.1-3-2.2-5.7 1-3.4 3.2-4.3 5.8-3.9l-.5 1.6c-2-.3-3.4.6-4 2.6-.6 1.9-.1 3.3 1.3 3.7 1.6.5 2.5-.9 3.5-2.9 1.3-2.5 2.7-4.7 5.8-3.8 2.6.8 3.4 3.3 2.5 6.2-1.1 4.1-3.8 5.3-6.6 4.6zM9.7 69.8l4.6-9 1.4.7-3.7 7.4 4 2 3.4-6.7 1.4.7-3.4 6.7 4.5 2.3 3.9-7.6 1.5.8-4.7 9.2-12.9-6.5zM18.7 53.7l4-5.3c1.5-2 3.8-2.4 5.7-1 1.4 1.1 1.9 2.4 1.3 4.1 1.3-.9 2.4-.6 4.1.6 1.9 1.3 2.5 1.4 2.8 1.3h.1l-1 1.6c-.4.1-.9-.2-2.9-1.5-1.8-1.2-2.9-.9-4 .6l-2.4 3.2 4.8 3.6-1.1 1.4-11.4-8.6zm6.5 2.7 2.6-3.4c1.2-1.6 1-3-.3-4-1.4-1.1-2.6-.9-3.8.7L21 53.2l4.2 3.2zM36.5 33.9l1.4-1.2 9.3 10.9-1.4 1.2-9.3-10.9zM44.3 27.6l1.6-1 10.8 4.9c.8.4 1.9 1 1.9 1l-6.3-9.9 1.4-.9 7.7 12.1-1.6 1-10.8-5c-.8-.3-1.8-.9-1.8-.9l6.3 9.9-1.5.9-7.7-12.1zM60.6 18l10.5-4.3.6 1.5-4.4 1.8 4.8 11.8-1.7.7-4.8-11.8-4.4 1.8-.6-1.5zM78.5 11.5l9.9-2.1.3 1.5-8.1 1.7.9 4.4 7.4-1.6.3 1.5-7.4 1.6 1.1 4.9 8.4-1.8.3 1.6-10.1 2.2-3-13.9zM96.7 8.5l6.7-.2c2.5-.1 4.3 1.5 4.3 3.8.1 1.7-.7 3-2.4 3.6v.1c1.5.5 2 1.5 2.2 3.6.2 2.3.5 2.9.8 3v.1l-1.9.1c-.3-.2-.4-.8-.6-3.2-.2-2.1-1.1-2.8-3-2.8l-4 .1.2 6-1.8.1-.5-14.3zm2 6.7 4.2-.1c2-.1 3-1.1 2.9-2.7-.1-1.7-.9-2.6-3-2.5l-4.3.1.2 5.2zM115.6 8.7l9.6 1.4-.2 1.6-7.8-1.1-.6 4.4 6.5 1-.2 1.5-6.5-1-1 6.7-1.8-.3 2-14.2zM135.3 12.8l1.9.6.7 15.2-1.9-.6-.1-4.6-5.4-1.7-2.8 3.7-1.8-.6 9.4-12zm-3.8 7.7 4.5 1.4-.1-5.1v-2.1s-.7 1-1.2 1.7l-3.2 4.1zM144.8 23.7c2-3.7 5.7-5.4 9.5-3.4 3 1.6 3.8 4.2 3 6.7l-1.6-.8c.5-1.7-.2-3.5-2.2-4.5-2.8-1.5-5.5 0-7.1 2.9-1.6 3.1-1 6.1 1.6 7.5 2.4 1.3 4.4.2 5.5-1.5l1.6.8c-.7 1.2-2 2.3-3.4 2.8-1.3.4-2.9.2-4.5-.7-3.6-2-4.5-5.9-2.4-9.8zM166 27.9l7.9 6.3-1 1.2-6.5-5.1-2.8 3.5 5.9 4.7-.9 1.2-5.9-4.7-3.1 3.9 6.7 5.3-1 1.3-8.1-6.4 8.8-11.2zM185.3 45.8l3.1 4.2c2.6 3.4 1.5 6.8-2 9.4-3.4 2.6-7 2.5-9.6-.9l-3-4 11.5-8.7zm-7.2 11.6c2 2.7 4.5 2.5 7.2.4s3.8-4.3 1.8-7l-2-2.7-8.9 6.7 1.9 2.6zM196.4 62.1l4.5 9.1-1.4.7-3.7-7.4-4.1 2 3.3 6.8-1.4.7-3.3-6.8-4.5 2.2 3.8 7.7-1.5.7-4.6-9.3 12.9-6.4zM194.4 80.5l.5 1.7c-2.3.9-3 2.7-2.3 5.3.6 1.9 1.8 3 3.5 2.5 1.9-.5 1.8-2.3 1.7-4.9-.2-2.6-.1-4.9 2.5-5.6 2.3-.7 4.2.8 5 3.6 1 3.4-.3 5.4-2.8 6.5L202 88c1.9-.8 2.5-2.4 1.9-4.4-.5-1.9-1.7-2.9-3.1-2.4-1.6.5-1.6 2.1-1.4 4.3.2 2.8.3 5.5-2.8 6.4-2.6.8-4.6-.9-5.5-3.9-1-4.1.6-6.5 3.3-7.5zM208 96.2l.3 1.8-14.1 2.1-.3-1.8 14.1-2.1zM196.9 116.9c-1.5-1.1-2.2-2.6-2.2-4.5 0-4 3-6.7 7.4-6.7 4.2 0 7.5 2.4 7.5 6.9 0 3.3-1.8 5.4-4.6 5.8v-1.9c1.9-.4 3-1.7 3-4 0-3.4-2.6-5-6-5-3.5 0-5.8 2.1-5.8 5s2 4.3 4.4 4.3h.3v-4.3h1.6v6.1h-7.6v-1.2l2-.5zM208.4 127.1l-.4 1.9-11 4.5c-.8.3-2 .7-2 .7l11.5 2.2-.3 1.6-14-2.7.3-1.8 11-4.5c.8-.3 1.9-.7 1.9-.7l-11.5-2.2.3-1.6 14.2 2.6z'
      className='st5UIDesign'
    />
    <path
      className='st0UIDesign'
      d='M169.9 174.9c-34.4 35.9-91.4 37.1-127.3 2.7-8-7.7-14.5-16.8-19.2-26.8'
    />
    <path
      className='st5UIDesign'
      transform='rotate(-60.771 183.48891693 156.5306277)'
      d='M181.5 154.5h4v4h-4z'
    />
    <path
      className='st5UIDesign'
      transform='matrix(.9815 -.1917 .1917 .9815 -24.4942 5.6027)'
      d='M14.7 127.4h4v4h-4z'
    />
    <path
      transform='rotate(-45 106.55126687 75.33526526)'
      className='st6UIDesign'
      d='M104.1 72.9h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 67.12397509 114.87994952)'
      className='st6UIDesign'
      d='M64.7 112.4h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 145.90439445 114.63059982)'
      className='st6UIDesign'
      d='M143.5 112.2h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 106.5283695 154.04434935)'
      className='st6UIDesign'
      d='M104.1 151.6h4.9v4.9h-4.9z'
    />
    <path
      fill='none'
      stroke='var(--color-badge-text)'
      stroke-width='1.2699746'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-miterlimit='3.9999'
      d='m103.77822 125.19578 10.52032-7.29088 8.71488 12.57507-10.52032 7.29088z'
    />
    <path
      className='st8UIDesign'
      d='m114.3 117.9-10.5 7.3-9.6-2.6-4.7-24.7 4.2-2.9 21.5 13zM100.3 109l-8.7-12.6'
    />
    <circle className='st8UIDesign' cx='101.7' cy='111' r='1.8' />
  </svg>
)

export default UserInterfaceDesign
